/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const CloudFogBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="m5.962 12-.039-.001a2 2 0 0 1-.921-3.733l.879-.508a.25.25 0 0 0 .124-.218L6 6.525V6.5a4.5 4.5 0 0 1 8.663-1.714l.495 1.2a.25.25 0 0 0 .255.153l1.292-.125a3 3 0 1 1 .537 5.976l-.12.01H5.962ZM17.4 13.992c0-.005.003-.008.007-.008a5 5 0 0 0-.71-9.975.265.265 0 0 1-.259-.156A6.501 6.501 0 0 0 4 6.5a.061.061 0 0 1-.03.053 4 4 0 0 0 1.88 7.446L5.85 14h11.54a.008.008 0 0 0 .009-.008ZM17.5 16a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-12A.5.5 0 0 1 5 17v-.5a.5.5 0 0 1 .5-.5h12Zm0 3a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-12A.5.5 0 0 1 5 20v-.5a.5.5 0 0 1 .5-.5h12Z" /></svg>);
const CloudFog = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={CloudFogBase} {...rest} ref={ref} />);
export default CloudFog;